import React from 'react';
import { Status } from '../utils/readiness';
import { cn } from '../utils/cn';
import { CheckCircle2, AlertCircle, AlertTriangle, Clock } from 'lucide-react';
interface NavStep {
  id: string;
  label: string;
  status: Status;
}
interface NavRailProps {
  steps: NavStep[];
  activeSection: string;
  onStepClick: (id: string) => void;
  topOffset?: number;
}
export function NavRail({
  steps,
  activeSection,
  onStepClick,
  topOffset = 24
}: NavRailProps) {
  const getStatusIcon = (status: Status) => {
    switch (status) {
      case 'Complete':
        return <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-77" />;
      case 'Missing Info':
        return <AlertTriangle className="w-4 h-4 text-yellow-500" data-id="element-78" />;
      case 'Needs Review':
        return <Clock className="w-4 h-4 text-blue-500" data-id="element-79" />;
      case 'Blocked':
        return <AlertCircle className="w-4 h-4 text-red-500" data-id="element-80" />;
    }
  };
  const getStatusColor = (status: Status) => {
    switch (status) {
      case 'Complete':
        return 'bg-green-100 text-green-800';
      case 'Missing Info':
        return 'bg-yellow-100 text-yellow-800';
      case 'Needs Review':
        return 'bg-blue-100 text-blue-800';
      case 'Blocked':
        return 'bg-red-100 text-red-800';
    }
  };
  return <div className="w-64 flex-shrink-0 hidden lg:block" data-id="element-81">
      <div className="sticky" style={{
      top: topOffset
    }} data-id="element-82">
        <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4 px-3" data-id="element-83">
          Workspace Nav
        </h3>
        <nav className="space-y-1" data-id="element-84">
          {steps.map(step => <button key={step.id} onClick={() => onStepClick(step.id)} className={cn('w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium rounded-lg transition-colors', activeSection === step.id ? 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200')} data-id="element-85">
              <span className="truncate mr-2" data-id="element-86">{step.label}</span>
              <span className={cn('flex-shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full', getStatusColor(step.status))} data-id="element-87">
                {getStatusIcon(step.status)}
              </span>
            </button>)}
        </nav>
      </div>
    </div>;
}